import useResizeObserver from '@react-hook/resize-observer';
import { useRef, useState } from 'react';

export const useElementWidth = () => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useResizeObserver(ref, (entry) => {
    setWidth(entry.contentRect.width);
  });
  return { width, ref };
};
